import React, { Component } from "react";
import { Form} from 'semantic-ui-react';
import  Logo  from "./logo";
import ValidacaoBrowser from "./ValidacaoBrowser";
import api from "../core/api";
import { login, logout} from "../core/auth";
import trocaSenhaImg from "../img/troca-senha.png";
import formatError from "../js/formatError"
import { isIOS, isSafari, isChrome, isFirefox } from 'react-device-detect';
import apiEsqueciSenha from "../core/apiEsqueciSenha";

class Login extends Component { 
  constructor(props) {
    super(props);
    this._buscarInfoEsqueciSenha();
    this.state = {
      username: "",
      password: "",
      tentativas: 0,
      error: "",
      exibirEsqueciSenha:"",
      urlEsqueciSenha:"",
      textoEsqueciSenha:""
    };
  }

  _buscarInfoEsqueciSenha() {
    apiEsqueciSenha.get("/buscarExibirEsqueciSenha",{}) 
    .then(res => {
        this.setState({
          exibirEsqueciSenha: res.data.exibir,
          urlEsqueciSenha: res.data.url,
          textoEsqueciSenha: res.data.texto
        });
        //console.log(res.data);
      }
    )
    .catch(err => {
      formatError(err.response,this);
      }
    );

  }
  
  handleChangePass = async e => {
    this.setState({ password: e.target.value });
  }

  handleClickEntrar = async e => {
    if(this.state.username === "") {
      this.setState({error : "Informe um usuário e uma senha."});
    } else if(this.state.password === "") {
      this.setState({error : "Informe uma senha."});
    } 
    
  }

  
  handleCancelar = async e => {
    logout();
    this.setState({
      error:"",
      username:"",
      password: "",
    });
  }
  handleLogin = async e => {
    e.preventDefault();
    // console.log(this.state);
    const { username, password , tentativas} = this.state;
    //const service='';
    if (!username || !password) {
      this.setState({ error: "Preencha usuário e senha para continuar!" });
    } else {
	  api.post("/login", {username, password, tentativas})
         .then( (response) => {
	          if (response.status !== 200) {
                  formatError(response, this);
	          } else {
		        login(response.data, username, password);
                this.props.history.push("/valid",{passo:1});
	          }
                     
         }).catch(error => {
               formatError(error.response, this);
         }
      );
    }
  };

  isValidBrowser() {
    if (isIOS && isSafari) {
      return true;
    }

    if (isChrome || isFirefox) {
      return true;
    }
    return false;
  }

  render() {
    if (!this.isValidBrowser()) {
       return ( <ValidacaoBrowser /> );
    }
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <h5 className="card-title text-center margin-top">
              <img src={trocaSenhaImg} className="img-responsive troca-senha" alt="Imagem responsiva" />
            </h5>
            <Form id="login" action="/" onSubmit={this.handleLogin} autoComplete="off">
              {this.state.error && <div className="msgError center">{this.state.error}</div>}
              <input 
                type="text" 
                id="usuario" 
                autoFocus={true}
                className="form-control margin-button-input bkg-verde" 
                placeholder="Usuário" 
                maxLength="30"
                onChange={e => this.setState({ username: e.target.value})} 
                required />
              <input 
                type="password" 
                id="senha" 
                className="form-control bkg-verde"
                placeholder="Senha" 
                maxLength="30" 
                onChange={this.handleChangePass}
                disabled={this.state.username === ""}
                required />
              
              <button 
                id="btnEntrar" 
                className="btn btn-primary btn-block margin-top-input text-uppercase" 
                type="submit" 
                disabled={this.state.username === "" || this.state.password === ""} 
                >
                  Acessar
              </button>
              <button 
                id="btnCancelar" 
                className="btn btn-secondary btn-block text-uppercase" 
                type="reset" 
                onClick={this.handleCancelar}>
                  Cancelar
              </button>
              <br/>
              <center>
              <a href={this.state.urlEsqueciSenha} >{this.state.textoEsqueciSenha}</a>
              </center>
              <Logo />
            </Form>
          </div>
        </div>
      </div>

    );
  }
}

export default Login;
